import React from 'react';
import PersonRed from '../../images/person-red.svg';
import SolidPerson from '../../images/user-solid.svg';
import { PressLessImage } from './image/gatsby-image-svg-fallback';
import AvatarModal from './avatar-modal';
import StyledLink from './styled-link';

interface AvatarProps {
    name?: string
    image?: IWPImage
    job?: string | null
    jobDescription?: string | null
    contact?: {
        email?: string
        fax?: string
        phone?: string
        title?: string
    }[] | null,
    focus?: { focus?: string }[]
    hasSingle?: boolean | null
    link?: string | null
    einrichtung?: null | {
        id: string
        title: string
        acfFields: {
            address: string | null
        }
        slug: string
        types: null | {
            nodes: {
                name: string | null
                slug: string | null
            }[]
        }
    }[]
}// email, phone, fax,

const Avatar : React.FC<AvatarProps> = ({
    name, image, job, jobDescription, link, contact, focus, einrichtung, hasSingle,
}: AvatarProps) => (
    <AvatarModal
        name={name}
        job={job}
        jobDescription={jobDescription}
        link={hasSingle && link ? link : undefined}
        contact={contact}
        focus={focus}
        einrichtung={einrichtung}
    >
        <div
            css={{
                textAlign: 'left',
                gap: '19px',
                width: '100%',
                height: 'auto',
                display: 'flex',
                position: 'relative',
                transition: '0.3s',
                marginLeft: '-10px',
                paddingLeft: '10px',
                paddingTop: '10px',
                paddingBottom: '10px',
                '@media (max-width: 767px)': {
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginLeft: 'unset',
                    paddingLeft: 'unset',
                },
            }}
        >
            <div css={{
                border: '5px solid var(--color-gray-white)',
                boxShadow: '0 3px 8px rgba(99, 106, 113, 0.09)',
                borderRadius: '500px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#E2E2E2',
                height: '165px',
                width: '165px',
                flex: 'none',
            }}
            >
                <SolidPerson
                    css={{
                        position: 'absolute',
                    }}
                />
                {image && (
                    <PressLessImage
                        image={image}
                        css={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '500px',
                            transform: 'translateZ(0px)',
                        }}
                    />
                )}
            </div>
            <div
                css={{
                    width: '100%',
                    height: 'auto',
                    display: 'flex',
                    // maxWidth: '227px',
                    flexDirection: 'column',
                    '@media (max-width: 767px)': {
                        alignItems: 'center',
                    },
                }}
            >
                <span
                    className="h4"
                    css={{
                        width: 'auto',
                        marginBottom: '10px',
                    }}
                >
                    {name}
                </span>
                {job && (
                    <span
                        className="p2"
                        css={{
                            marginBottom: '11px',
                            '@media (max-width: 767px)': {
                                textAlign: 'center',
                            },
                        }}
                    >
                        <span css={{ fontWeight: '600' }}>{job}</span>
                        <br />
                        <span>{jobDescription}</span>
                    </span>
                )}
                {contact && contact.length > 0 && (
                    <div
                        css={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            flexDirection: 'row',
                        }}
                        className="p2"
                    >
                        <PersonRed css={{
                            marginRight: '4px',
                        }}
                        />
                        <StyledLink
                            small
                            css={{
                                fontWeight: 700,
                            }}
                        >
                            Kontakt
                        </StyledLink>
                    </div>
                )}
            </div>
        </div>
    </AvatarModal>
);

export default Avatar;
